export const formData = {
  username:{
    value: '',
    error: false,
    isVisited: false,
    isRequired: true,
    isValid: false,
    config:{
      id:'username',
      type:'text',
      fullWidth: true,
      icon:{name:'person', position:'start'}
    },
    rules:{
      type:'distance',
      min:1,
      max:100
    }
  },
  password:{
    value: '',
    error: false,
    isVisited: false,
    isRequired: true,
    isValid: false,
    config:{
      id:'password',
      type:'password',
      fullWidth: true,
      icon:{name:'lock', position:'start'}
    },
    rules:{
      type:'distance',
      min:1,
      max:100
    }
  },
}